import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';
import styles from './lineChart3.module.css';
import * as echarts from 'echarts';


var myLineChart = null;

class LineChart3 extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this, [
            'initLineBar'
        ]);

        this.state = {

        };

    }

    componentDidMount() {
        this.initLineBar();
    }

    componentDidUpdate() { // 组件更新后触发


    }

    componentWillUnmount (){
        myLineChart.dispose();
    }


    initLineBar() {

            const option = {
                legend: { //图例
                    data: ['徽章数', '点赞数'],
                    right: '3%',
                    top: '2%',
                    // itemGap: 40,//图例每项之间的间隔 number
                    // itemWidth: 50,//图例标记的图形宽度
                    itemHeight: 15,//圆点大小
                    itemStyle: {
                        // borderWidth: 0,
                        borderColor: ['#fbbb02', '#35e3ea'],//图例圆圈颜色
                    },
                    textStyle: {
                        fontSize: 16,//字体大小
                        color: ['#fbbb02', '#35e3ea']//字体颜色
                    },
                },
                tooltip: {//提示框组件
                    trigger: 'axis',//触发类型 item(散点图，饼图) axis(柱状图，折线图等)
                    axisPointer: {
                        type: 'cross',//指示类型
                        label: {
                            // 横纵坐标指示区块颜色
                            backgroundColor: '#6a7985'
                        },

                    },
                    textStyle: {
                        //fontSize: 16,//字体大小
                        color: 'black',//字体颜色
                    },
                },
                grid: {//图标距离容器的边距
                    left: '6%',
                    top: '20%',
                    right: '8%',
                    bottom: '15%',
                    // containLabel: true
                },
                xAxis: [{//直角坐标系 grid 中的 x 轴
                    // name:'年-月',
                    // nameTextStyle:{
                    //     color: '#000000',
                    //     fontSize: 16,
                    //     padding: [0, 40, 0, 10]
                    // },
                    axisLabel: {//坐标轴刻度标签
                        margin: 15,//刻度标签与轴线之间的距离
                        // color: '#000000',
                        textStyle: {
                            fontSize: 16,
                            color: '#000000'//字体颜色
                        },
                    },
                    axisLine: {
                        lineStyle: {//x轴
                            color: '#b8e157',
                            width: 1, //这里是为了突出显示加上的
                        }
                    },
                    //boundaryGap: false,//坐标轴两边留白策略
                    axisTick:{show:false},
                    data: ['21-3','21-4','21-5','21-6','21-7','21-8','21-3','21-4','21-5','21-6','21-7','21-8'],
                }],
                yAxis: [{
                    // name:'数量',
                    // nameTextStyle:{
                    //     color: '#000000',
                    //     fontSize: 16,
                    // },
                    splitLine: {//坐标轴在 grid 区域中的分隔线
                        lineStyle: {
                            color: '#b8e157',
                            width: 1,
                        }
                    },
                    axisLabel: {
                        margin: 10,
                        textStyle: {
                            fontSize: 16,
                            color: '#000000',
                        },
                    },
                    axisLine: {
                        lineStyle: {//x轴
                            color: '#b8e157',
                            width: 1, //
                        },
                        show: true//是否显示坐标轴轴线
                    },
                }],

                series: [
                    {
                        name: '徽章数',
                        type: 'line',
                        color:'#fbbb02',
                        showAllSymbol: true,
                        symbol: 'circle',
                        symbolSize: 12,
                        lineStyle: {
                            width: 2
                        },

                        label: {
                            //show: true,
                            textStyle: {
                                color: '#fbbb02',
                            }
                        },
                        areaStyle: {//区域填充样式。设置后显示成区域面积图
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: '#fbbb02'
                            },
                                {
                                    offset: 1,
                                    color: '#ffffff00'
                                }]),
                            //opacity: 0.1,
                            origin: 'start',//填充坐标轴底部（非 inverse 情况是最小值）到数据间的区域

                        },
                        data: [10,26,55,46,69,24],
                    },
                    {
                        name: '点赞数',
                        type: 'line',
                        showAllSymbol: true,
                        symbol: 'circle',
                        color:'#35e3ea',
                        symbolSize: 12,
                        lineStyle: {
                            width: 2
                        },
                        label: {
                            //show: true,
                            position: 'top',
                            textStyle: {
                                color: '#35e3ea',
                            }
                        },
                        areaStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: '#35e3ea'
                            },
                                {
                                    offset: 1,
                                    color: '#ffffff00'
                                }]),
                            origin: 'start'//填充坐标轴底部（非 inverse 情况是最小值）到数据间的区域
                        },
                        data: [14,46,65,56,159,20],
                    },
                ],
            };

            myLineChart = echarts.init(document.getElementById('lineChart3'));
            myLineChart.setOption(option, true)

    }


    render() {

        return (
            <div className={styles.root}>
                <div id="lineChart3" className={styles.echart}></div>
                <div className={styles.shuliang}>数量</div>
                <div className={styles.name}>年-月</div>
            </div>
        )
    }
}


export default LineChart3;
